export default {
  list: {
    title: 'internal expeditions',
    name: 'internalexpeditions',
    class: 'min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center',
    sousTable: true,
    options: {
      defaultPageSize: 5,
      actions: {
        isActive: true,
        name: 'Actions',
        buttons: [
          {
            text: 'Add internal expedition',
            icon: 'add',
            link: '/internalexpeditions/new',
            color: 'primary',
          },
        ],
      },
    },
    columns: [
      {
        name: 'ID',
        elements: [
          {
            items: [
              {
                name: 'id',
                class: 'text-left float-left',
              },
            ],
          },
        ],
      },
      {
        name: 'country',
        elements: [
          {
            items: [
              {
                name: 'country',
                class: 'text-center font-bold',
              },
            ],
          },
        ],
      },
      {
        name: 'date',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                date: true,
                name: 'date',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'details',
        model: 'internalexpeditions',
        title: 'Products',
      },
      {
        name: 'reception_date',
        class: 'text-center',
        elements: [
          {
            items: [
              {
                class: '',
                date: true,
                name: 'arrivalDate',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'status',
        class: 'text-center',
        elements: [
          {
            items: [
              {
                class:
                  'border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none',
                name: 'status',
                options: item => {
                  switch (item) {
                    case 'expedited':
                      return 'color: rgb(233 147 19); border-color: rgb(233 147 19);';
                      break;
                    case 'received':
                      return 'color:rgb(58 217 18); border-color: rgb(58 217 18);';
                      break;
                    case 'cancelled':
                      return 'color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);';
                      break;
                  }
                },
              },
            ],
          },
        ],
      },
    ],
    columnsDialog: {
      details: 'details',
      elements: [
        {
          class: '',
          name: 'image',
          referent: 'details',
          attribut: 'product',
          items: [
            {
              name: 'picture',
            },
          ],
        },
        {
          class: '',
          name: 'id',
          referent: 'details',
          attribut: 'product',
          items: [
            {
              name: 'id',
            },
          ],
        },
        {
          class: '',
          name: 'name',
          referent: 'details',
          attribut: 'product',
          items: [
            {
              name: 'name',
            },
          ],
        },
        {
          class: '',
          name: 'warehouses',
          referent: 'details',
          items: [
            {
              name: 'warehouses',
            },
          ],
        },

        // {
        //     class: "",
        //     referent: "details",
        //     name: "quantity_received",
        //     attribut: 'quantity',
        //     items: [{
        //         name: "received",
        //         name_1: "defective",
        //     }, ]
        // },
        // {
        //     class: "",
        //     referent: "details",
        //     name: "Quantity defective",
        //     attribut: 'quantity',
        //     items: [{
        //         name: "defective",
        //     }, ]
        // },
      ],
    },
    actions: {
      name: 'actions',
      width: '10px',
      class: 'justify-end',
      elements: [
        // {
        //     icone: "remove_red_eye",
        //     color: "success",
        //     key: 'read',
        //     id: "",
        //     role: true,
        //     link: '/internalexpeditions/detail',
        //     tooltip: "Update",
        // },
        {
          icone: 'edit',
          color: 'success',
          role: true,
          key: 'update',
          link: '/internalexpeditions/edit',
          tooltip: 'Update',
        },
        {
          icone: 'delete',
          color: 'danger',
          role: true,
          key: 'delete',
          tooltip: 'Delete',
        },
      ],
    },
    filters: {
      name: 'internalexpeditions',
      elements: {
        search: {
          options: {
            icon: 'search',
            label: 'search',
            class: '',
            hint: 'id, id product ...',
          },
          value: null,
          type: 'search',
          validate: {
            trim: true,
            required: false,
            minlength: 0,
          },
        },
        champs: [
          {
            label: 'status',
            key: 'status',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
        ],
      },
    },
  },
};
